import { View } from 'react-native';
import { useMemo } from 'react';
import { Text } from '@/components/ui/text';
import { useTranslation } from 'react-i18next';

export interface NutritionPreviewProps {
  kcal?: number;
  macros?: {
    fats?: number;
    carbs?: number;
    proteins?: number;
    fiber?: number;
  };
}

export const NutritionPreview = ({
  kcal,
  macros = {},
}: NutritionPreviewProps) => {
  const { t } = useTranslation('meal');
  const obj = useMemo(() => ({ ...macros, kcal }), [kcal, macros]);
  const isEverythingEmpty = Object.values(obj).every((v) => !v);

  if (isEverythingEmpty) {
    return null;
  }
  return (
    <>
      {Object.entries(obj)
        .filter(([, value]) => value !== undefined && value !== null)
        .map(([key, value]) => {
          // Round kcal to whole number, other nutrition to 1 decimal place
          const roundedValue =
            key === 'kcal'
              ? Math.round(value as number)
              : Number((value as number).toFixed(1));

          return (
            <View key={key} className="flex flex-row gap-x-1 flex-wrap">
              <Text className="text-muted-foreground text-xs">
                {t(`nutrition.${key}.shortSign`, { value: roundedValue })}
              </Text>
            </View>
          );
        })}
    </>
  );
};
